export default __webpack_public_path__ + "static/media/settings-nav.633c0f9e.svg";